<template>
  <div id="re_list">
    <van-nav-bar
      title="报告单列表"
      left-text="返回"
      left-arrow
      right-text="新建"
      @click-left="onClickLeft"
      @click-right="onClickRight"
    />
    <van-list
      v-model="loading"
      :finished="finished"
      finished-text="没有更多了"
      @load="onLoad"
    >
      <div v-for="(item, index) in list" :key="index" class="loading_list loading_list_item" @click="showReport(item)">
        <div class="loading_list_header">
          <div class="loading_list_code">{{ item.report_no }} </div>
          <div class="loading_list_bottom_text">{{ item.create_at }}</div>
        </div>
        <div class="loading_list_content">
          <div class="loading_list_brand">品牌: {{ item.brand_en }} </div>
          <div class="loading_list_city">城市: {{ item.city_cn }} </div>
          <div class="loading_list_market">商场: {{ item.market_cn }}</div>
          <div class="loading_list_shop">店铺: {{ item.store_cn }}</div>
          <div class="loading_list_shop">维修类型: {{ item.ma_type_cn }}</div>
          <div class="loading_list_shop">工作类型: {{ item.ma_cate_cn }}</div>
          <div class="loading_list_shop">{{ item.report_title }}</div>
          <div class="loading_list_shop">签单: <van-icon v-if="item.sign_file_list && item.sign_file_list.length > 0" color="#1989fa" name="success" /><van-icon v-else name="cross" color="#ee0a24" /></div>
          <div class="loading_list_shop">完工日期: {{ item.completed_at }}</div>
        </div>
      </div>
    </van-list>
  </div>
</template>

<script>
import {getReportList} from "../../api/report";

const STATUS = ['', '待接受', '已提交', '待维修', '已完工', '待验收', '验收通过', '待返工']
const REPAIR_TYPES = ['定期维保', '紧急维修', '改造工程']

const COLOR_TAG_TYPES = {
  yellow: 'warning',
  red: 'danger',
  green: 'success',
  blue: 'primary'
}

export default {
  name: 'reimbursement_list',
  data () {
    return {
      value2: '',
      active: 0,
      statusOptions: [],
      option2: [],
      finished: '',
      loading: false,
      list: [],
      color_tag_types: COLOR_TAG_TYPES
    }
  },
  created () {
    this.initList(this.page)
  },
  methods: {
    onClickRight() {
      this.$router.push({ path: '/order_mobile_create_report' })
    },
    createReim() {
      this.$router.push({ path: '/order_reimbursement' })
    },
    async initList (page) {
      let queryData = {page: page}
      await getReportList(queryData).then((res) => {
        if (res.data.data.list) {
          const data = res.data.data.list
          if (data.length < 20) {
            this.finished = true
          }
          this.list = data
        } else {
          this.finished = true
          this.list = []
        }
      })
    },
    onLoad () {
      setTimeout(() => {
        if (this.finished) {
          return false
        }
        if (this.refreshing) {
          this.list = []
          this.refreshing = false
        }
        this.initList(this.page + 1)
        this.loading = false
      }, 1000)
    },
    onRefresh () {
      if (this.finished) {
        return false
      }
      // 清空列表数据
      this.finished = false

      // 重新加载数据
      // 将 loading 设置为 true，表示处于加载状态
      this.loading = true
      this.onLoad()
    },
    onClickLeft () {
      this.$router.push({path: '/index'})
    },
    changeTypes (index) {
      this.active = index
      let status = ''
      if (index === 0) {
        status = ''
      } else if (index === 1) {
        status = 0
      } else if (index === 2) {
        status = 1
      } else if (index === 3) {
        status = 2
      }
      // 0已提交、1审批通过、2拒绝、3保存
      this.initList(1, status)
      this.list = []
    },
    changeStatus (val) {
      this.checkStatus = val
      this.list = []
      this.finished = false
      this.initList(1, val, this.value2)
    },
    changeSort (val) {
      this.value2 = val
      this.list = []
      this.initList(1, this.checkStatus, val)
    },
    checkStatus() {

    },
    showReport(item) {
      this.$router.push({path: '/order_create_report', query: {appo_task_id: item.appo_task_id, ma_item_id: item.ma_item_id, order_id: item.order_id, report_id: item.id}})
    }
  }
}
</script>

<style scoped>
#re_list {
  background: #F5F5F5;
}
.loading_list {
  background-color: #fff;
  margin: 10px 5px;
  border-radius: 4px;
}
.loading_list_item {
  width: 96%;
  margin: 5px auto;
  border-radius: 10px;
  overflow: hidden;
  padding-bottom: 10px;
}
.loading_list_header { overflow: hidden; padding-top: 10px; padding-right: 2%; }
.loading_list_code { float: left; color: #000000; font-weight: 500; width: 60%; font-size: 16px; height: 20px; text-align: left;padding-left: 5%; }
.loading_list_status { float: right !important; text-align: right; width: 30%; font-size: 14px; height: 16px; }
.loading_list_content { overflow: hidden; text-align: left; padding-left: 5%; margin: 6px auto; font-size: 14px; color: #717989;}
.loading_list_content_left { float: left; width: 40%; padding-left: 5%; text-align: left; }
.loading_list_content_right { float: right; text-align: left; width: 50%; }
.loading_list_bottom_text {
  font-size: 12px; text-align: right;
  height: 15px;
  float: right;
  width: 35%;
}
.loading_list_job_type {
  font-size: 14px;
  color: #717989;
}
.loading_list_bottom {
  padding: 0 5% 10px;
}
.loading_list_bottom div {
  float: left;
}
</style>



// WEBPACK FOOTER //
// src/views/order/report_list.vue